import axios from 'axios';

async function createCompanyAddress(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/addresses`, data);

  return response.data;
}

async function deleteAddress(addressId, data) {
  const response = await axios.delete(`/addresses/${addressId}`, { data });

  return response.data;
}

async function listCompanyAddresses(companyId) {
  const response = await axios.get(`/companies/${companyId}/addresses`);

  return response.data;
}

async function searchAddress(data, inseeCode = null, postcode = null) {
  const queryParams = new URLSearchParams('limit=50&type=housenumber&autocomplete=1');
  queryParams.set('q', data);
  if (inseeCode) queryParams.set('citycode', inseeCode);
  if (postcode) queryParams.set('postcode', postcode);

  const url = `https://api-adresse.data.gouv.fr/search?${queryParams.toString()}`;
  const response = await axios.get(url);

  return response.data;
}

async function updateAddress(addressId, data) {
  const response = await axios.put(`/addresses/${addressId}`, data);

  return response.data;
}

const addressService = {
  createCompanyAddress,
  deleteAddress,
  listCompanyAddresses,
  searchAddress,
  updateAddress,
};

export default addressService;
